import { VerbFetch } from '../VerbFetch';

export const sendInterest = (params) => {
    const { body, pathsContext } = params;

    const fetchOptions = {
        method: 'POST',
        body
    };

    return () =>
        VerbFetch(`${pathsContext.adminServerUrl}/trackinterest`, fetchOptions).catch((err) => {
            console.error(err);
        });
};

export const postUnsubscribe = (params) => {
    const { email, pathsContext } = params;
    const fetchOptions = {
        method: 'POST',
        body: {
            email
        }
    };

    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/email/unsubscribe`, fetchOptions).then(() => {
            dispatch({
                type: 'POST_UNSUBSCRIBE'
            });
        });
};

export const postTestEmail = (params) => {
    const { body, pathsContext } = params;

    const fetchOptions = {
        method: 'POST',
        body
    };

    return () =>
        VerbFetch(`${pathsContext.serverUrl}/email/sendtestemail`, fetchOptions).catch((err) => {
            console.error(err);
        });
};

export const sendAdminToUserEmails = (params) => {
    const { recipients, note, adminFirstname, adminLastname, pathsContext } = params;
    const fetchOptions = {
        method: 'POST',
        body: {
            recipients,
            note,
            adminFirstname,
            adminLastname
        }
    };
    return VerbFetch(`${pathsContext.adminServerUrl}/email/admintousers`, fetchOptions)
        .then((result) => result)
        .catch((err) => {
            console.error(err);
            throw err;
        });
};

export const sendEmployeeNudges = (params) => {
    const { emails, companyId, teamPermalink = '', pathsContext } = params;

    const fetchOptions = {
        method: 'POST',
        body: {
            emails,
            companyId,
            teamPermalink
        }
    };

    return () =>
        VerbFetch(`${pathsContext.adminServerUrl}/email/employeenudges`, fetchOptions)
            .then((result) => result)
            .catch((err) => {
                console.error(err);
            });
};
